import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function DoneIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="16.0664" cy="15.9673" r="13" fill="#81D39D" stroke="#81D39D" strokeWidth="2" />
			<path d="M12 16.6685L14.9029 18.8942L20 13" stroke="white" strokeWidth="2" strokeLinecap="round" />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<DoneIcon fill={props.fill} />
		</div>
	);
}